export const ACTION_SELECT_DROPDOWN_MAX_WIDTH = 288 // px

export const ACTION_SELECT_DROPDOWN_STYLES = {
  maxWidth: ACTION_SELECT_DROPDOWN_MAX_WIDTH,
}
